// @ts-ignore
import React from "react";

import { JiraSoftwarePageTemplatePaidLpJswTracker } from "../../templates/jira-software-page/src";

export const JiraSoftwarePagePaidLpJswTracker = () => (
    <JiraSoftwarePageTemplatePaidLpJswTracker />
);
